import PropTypes from "prop-types";
import React from "react";
import STSComponent from "../../STSComponent/STSComponent";
import "./switch.scss";

class Switcher extends STSComponent {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  shouldComponentUpdate(nextProps) {
    return nextProps.isEnabled !== this.props.isEnabled;
  }

  handleClick = () => {
    const { location, isEnabled, id, onClick, arrayIndex } = this.props;

    this.updateData(location, "switch", id, !isEnabled, arrayIndex);

    if (onClick) {
      onClick();
    }
  };

  render() {
    const { text, isEnabled, className } = this.props;
    const switchStyle = isEnabled ? "enabled" : "disabled";
    return (
      <div
        onClick={this.handleClick}
        className={`switch-wrap ${className ? className : ""}`}
      >
        <div className={`switch-btn ${switchStyle}`} />
        <span className={`switch-button-text `}>{text}</span>
      </div>
    );
  }

  static propTypes = {
    text: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    isEnabled: PropTypes.bool.isRequired,
    location: PropTypes.object.isRequired,
    updateData: PropTypes.func,
    onClick: PropTypes.func,
    className: PropTypes.string,
    arrayIndex: PropTypes.number,
  };
}

export default Switcher;



// WEBPACK FOOTER //
// ./src/components/FormComponents/SwitchButton/Switch.js